module.exports = __webpack_public_path__ + "img/action-arrow-right.f9a24a32.png";